import { Button, Loader, Modal, Scrollbar } from '@repo/go-ui';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { CopyToAnotherRoomStore } from './copy-to-another-room.store';
import type { OptionsService } from 'src/services/directory-service/options-service';

import { FormControl } from '../directory-form-sidebar/features/form/form-control';

import { ConfirmCopyModal } from './confirm-copy-modal';

import styles from './copy-to-another-room-modal.module.scss';

type Props = {
  store: CopyToAnotherRoomStore;
  optionsService: OptionsService;
};

export const CopyToAnotherRoomModal = wrap<Props>(function CopyToAnotherRoomModal({ store, optionsService }) {
  const { t } = useTranslation();

  const { isOpened } = store;

  const handleCancel = () => {
    store.setIsOpened(false);
    store.resetControls();
  };

  return (
    <>
      <Modal
        open={isOpened}
        title={t('directory:components.copyToAnotherRoom.copyingData')}
        onClickOutside={null}
        closeIcon={null}
        headerClassName={styles.modalHeader}
      >
        <div className={styles.modalWrapper}>
          <div className={styles.modalContentWrapper}>
            <Scrollbar>
              <p className={styles.modalFormInfoText}>
                {t('directory:components.copyToAnotherRoom.optionsForCopying')}
              </p>
              <div className={styles.controlsWrapper}>
                {store.view.copyModal.sourceRoom.map((fieldView) => {
                  const onChange = (fieldId: string, value: unknown) => {
                    store.onFieldValueChange('source', fieldId, value);
                  };

                  return (
                    <FormControl
                      key={fieldView.attrName}
                      controlView={fieldView}
                      data={store.sourceControlsData}
                      optionsService={optionsService}
                      required={store.requiredFields.includes(fieldView.fieldId)}
                      onChange={onChange}
                    />
                  );
                })}
              </div>

              <p className={styles.modalFormInfoText}>{t('directory:components.copyToAnotherRoom.pasteOptions')}</p>

              <div className={styles.controlsWrapper}>
                {store.view.copyModal.targetRoom.map((fieldView) => {
                  const onChange = (fieldId: string, value: unknown) => {
                    store.onFieldValueChange('target', fieldId, value);
                  };

                  return (
                    <FormControl
                      key={fieldView.attrName}
                      controlView={fieldView}
                      data={store.targetControlsData}
                      optionsService={optionsService}
                      required={store.requiredFields.includes(fieldView.fieldId)}
                      onChange={onChange}
                    />
                  );
                })}
              </div>
            </Scrollbar>
          </div>

          <div className={styles.modalButttonsWrapper}>
            <Button className={styles.modalButton} variant="danger" onClick={handleCancel}>
              {t('common:cancel')}
            </Button>
            <Button className={styles.modalButton} variant="success" onClick={store.applyCopying}>
              {t('common:apply')}
            </Button>
          </div>

          {store.isLoading && <Loader />}
        </div>
      </Modal>
      <ConfirmCopyModal
        isOpened={store.isConfirmModalOpened}
        onCancel={store.denyCopying}
        onApply={store.confirmCopying}
      />
    </>
  );
});
